// Libs
import React, { useState, useEffect } from 'react';

// Own Libs
import * as ui from '@digital/ui';

//Api
import { getAllCrfFechamento } from '@app/api/crf/crffechamento';

//Files
import FechamentoModuloExecutado from './fechamentoModuloExecutado';
import FechamentoControleRfa from './fechamentoControleRfa';
import FechamentoPluriAnual from './fechamentoPluriAnual';
import FechamentoCicloOrcamentario from './fechamentoCicloOrcamentario';
import FechamentoCurvaEconomica from './fechamentoCurvaEconomica';
import CrfFechamentoExecutiveSummary from './fechamentoExecutiveSummary';
import CrfFechamentoProjetoOverView from './fechamentoCrfProjetoOverview';

//Utils
import { hasPermission } from '@app/helpers/permissions';
import AreaExecutiveSummary from '@app/views/crf/Modulo/ContaResultado/Dashboard/AreaExecutiveSummary';

const CrfFechamento = () => {
  const [allFechamento, setFechamento] = useState(() => getAllCrfFechamento);

  useEffect(() => { }, []);

  return (
    <ui.CrudMasterDetailView
      getAllItems={allFechamento}
      filterPredicate={(item, value) => item.ano.toString().startsWith(value)}
      titleExtractor={item => item.ano.toString() + '/' + item.mes.toString()}
      detailTitleExtractor={item => item.ano.toString() + ' - ' + item.mes.toString()}
      descriptionExtractor={item => `Versão: ${item.versao}`}>
      <ui.CrudContext.Consumer>
        {({ selectedItem }) => (
          <ui.CompositeView>
            {hasPermission(['FECHAMENTO_EXECUTIVE_SUMMARY_VISUALIZAR']) && selectedItem ? (
              <ui.GridView icon="files-new_by_copy" id={`executiveSummary`} noform title="EXECUTIVE SUMMARY">
                <CrfFechamentoExecutiveSummary fechamentoId={selectedItem.id} />
              </ui.GridView>
            ) : (
              () => { }
            )}

            {hasPermission(['FECHAMENTO_CURVA_ECONOMICA_VISUALIZAR']) && selectedItem ? (
              <ui.GridView icon="files-new_by_copy" id="cruvaEconomica" noform title="CURVA ECONÔMICA">
                <FechamentoCurvaEconomica fechamentoId={selectedItem.id} />
              </ui.GridView>
            ) : (
              () => { }
            )}

            {hasPermission(['FECHAMENTO_AREA_EXECUTIVE_SUMMARY_VISUALIZAR']) && selectedItem ? (
              <ui.GridView icon="files-new_by_copy" id="areaExecutiveSummay" noform title="ÁREA - EXECUTIVE SUMMARY">
                <AreaExecutiveSummary
                  fechamentoId={selectedItem.id}
                  telaInicial={false}
                />
              </ui.GridView>
            ) : (
              () => { }
            )}

            {true && hasPermission(['FECHAMENTO_REPORT_PERFORMACE_PROJECT_VISUALIZAR']) && selectedItem ? (
              <ui.GridView icon="files-new_by_copy" id="projetoOverView" noform title="REPORT PERFORMACE PROJECT">
                <CrfFechamentoProjetoOverView fechamentoId={selectedItem.id} />
              </ui.GridView>
            ) : (
              () => { }
            )}

            {true && selectedItem ? (
              <ui.GridView icon="files-new_by_copy" id="cicloOrcamentario" noform title="CICLO ORÇAMENTARIO">
                <FechamentoCicloOrcamentario fechamentoId={selectedItem.id} />
              </ui.GridView>
            ) : (
              () => { }
            )}

            {true && selectedItem ? (
              <ui.GridView icon="files-new_by_copy" id="pluriAnual" noform title="PLURIANUAL">
                <FechamentoPluriAnual fechamentoId={selectedItem.id} />
              </ui.GridView>
            ) : (
              () => { }
            )}

            {true && selectedItem ? (
              <ui.GridView icon="files-new_by_copy" id="controleRfa" noform title="CONTROLE RFA">
                <FechamentoControleRfa fechamentoId={selectedItem.id} />
              </ui.GridView>
            ) : (
              () => { }
            )}

            {true && selectedItem ? (
              <ui.GridView icon="files-new_by_copy" id="moduloExecutado" noform title="MODULO EXECUTADO">
                <FechamentoModuloExecutado fechamentoId={selectedItem.id} />
              </ui.GridView>
            ) : (
              () => { }
            )}

          </ui.CompositeView>
        )}
      </ui.CrudContext.Consumer>
    </ui.CrudMasterDetailView>
  );
};

export default CrfFechamento;
